import VerifyCodeByNewEmail from './VerifyCodeByNewEmail'

export default VerifyCodeByNewEmail
